
import {useContext, useEffect, useState} from "react";
import {appContext} from "../state";
import {Alert, App, Button, Flex, Input, Statistic} from "antd";
import {googleLogout} from "@react-oauth/google";
import {Link} from "react-router-dom";
import {isSignedIn} from "../utils/auth";
import loadScript from "../utils/script";
import {clearUrl} from "../utils/general";

function RouteSettings(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const [hasSubscriptionManageUrl, setHasSubscriptionManageUrl] = useState('')
    //const [messageApi, contextHolder] = message.useMessage();
    const { message, modal, notification } = App.useApp();

    useEffect(() => {
        hasSubscription().then( () => {})
        loadStripe().then( () => {})
    }, []);

    async function loadStripe () {
        loadScript('https://js.stripe.com/v3/').then( async () => {
            console.log('STRIPE_READY')
        })
        await checkStripCheckoutStatus()
    }

    async function showStripeCheckout() {
        const fetchClientSecret = async () => {
            let headers = new Headers();
            headers.append('content-type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
            }
            const response = await fetch(process.env.REACT_APP_SERVER_API_HOST+"/user/checkout", requestOptions);
            const { clientSecret } = await response.json();
            console.log('CLIENT_SECRET',clientSecret)
            return clientSecret;
        };

        const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_API_KEY);
        const checkout = await stripe.initEmbeddedCheckout({fetchClientSecret,});
        checkout.mount('#checkout');
    }


    // 4242 4242 4242 4242 
    async function checkStripCheckoutStatus() { // After purchasing user get redirected here with the return_url
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sessionId = urlParams.get('session-id');
        console.log('SESSION_ID',sessionId)
        if (sessionId) {
            let headers = new Headers();
            headers.append('content-type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
            }
            const response = await fetch(process.env.REACT_APP_SERVER_API_HOST+`/user/checkout-status?session-id=${sessionId}`,requestOptions);
            const session = await response.json();
            if (session.status === 'open') { // Remount embedded Checkout
                console.log('STRIPE_CHECKOUT_OPEN',session)
                //window.location.replace('http://localhost:4242/checkout.html')
            } else if (session.status === 'complete') {
                console.log('STRIPE_CHECKOUT_SUCCESS',session)
                message.open({type: 'success', content: 'Purchase successful! Thanks for supporting us!'})
                clearUrl()
            }
        }
    }

    function onSignOut () {
        googleLogout()
        localStorage.removeItem('token')
        localStorage.removeItem('app-state')
        window.location.reload()
    }

    function onTest () {
        //message.success( 'Copied to clipboard')
        message.open({type: 'error', content: 'Login failed!'})
        // modal.warning({title: 'This is a warning message', content: 'some messages...some messages...',});
        /* notification.info({
             message: 'Notification topLeft',
             description: 'Hello, Ant Design!!',
             placement: 'topLeft',
         });*/
    }

    async function hasSubscription () {
        const url = process.env.REACT_APP_SERVER_API_HOST+"/user/has-subscription"
        try {
            let headers = new Headers()
            headers.append('Content-Type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {method: 'GET', headers: headers};

            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            if (response.status === 200) {
                const json = await response.json();
                console.log('RESPONSE:',json)
                if (json.hasSubscription) {
                    setHasSubscriptionManageUrl(json.manageSubscriptionUrl)
                }
            } else {

            }

        } catch (error) {
            console.error(error.message);
        }
    }

    function showPricingModal () {
        let newAppState = {...appState}
        newAppState.isPricingModalOpen = true
        setAppState(newAppState)
    }

    function openCheckoutLemonSqueezy () {
        if (!window.LemonSqueezy) {
            return
        }
        console.log('window.LemonSqueezy',window.LemonSqueezy)
        const checkoutUrl = 'https://mocky.lemonsqueezy.com/buy/6e118147-d873-447c-a09e-9986b154361e';
        window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    return (
        <div className="view settings">
            <div id="checkout"></div>
            <Flex gap="middle" vertical>
                <Statistic title="Version" value={process.env.REACT_APP_VERSION}/>
                {appState.user?.email ?
                    <Input prefix="Email:" disabled={true} defaultValue={appState.user?.email}></Input> : false}
                {appState.user?.authProvider === 'GOOGLE' ? <div>Logged in via: Google</div> : false}

                <Link to={"/signup"}><Button>Sign up</Button></Link>
                {!isSignedIn(appState) ? <Link to={"/signin"}><Button>Sign in</Button></Link> : false}
                {isSignedIn(appState) ? <Button onClick={onSignOut}>Sign out</Button> : false}
                {/*hasSubscriptionManageUrl !== '' ? <a target="_blank" href={hasSubscriptionManageUrl}><Button>Manage my subscription</Button></a> : false*/}

                {/*<Button onClick={openCheckoutLemonSqueezy}>Buy</Button>*/}
                {<Button onClick={showStripeCheckout}>Buy</Button>}
                {<a target="_blank" href={process.env.REACT_APP_LANDING_PAGE + "/pricing"}><Button>Upgrade</Button></a>}
                {process.env.REACT_APP_ENV !== 'PRODUCTION' ? <Button onClick={onTest}>Test</Button> : false}

                {process.env.REACT_APP_ENV !== '!' ? <Button onClick={() => window['test'].notExisting()}>Throw Error</Button> : false}
                {/*process.env.REACT_APP_ENV !== 'PRODUCTION' ?  <Button onClick={showPricingModal}>Buy</Button> : false*/}

                <Alert
                    message="Subscriptions"
                    description="When purchasing a subscription please use the same email that you used for creating your account."
                    type="info"
                    showIcon
                />

            </Flex>

        </div>
    );
}

export default RouteSettings;
